<template>
    <v-menu
        slot="content"
        class="account-feedback"
        transition="slide-y-transition"
        :close-on-content-click="false"
        z-index="100"
        bottom
    >
        <!-- <template v-slot:activator="{ on }">
            <v-btn
                dark
                icon
                v-on="on"
            >
                <v-badge
                    class="feedback-badge"
                    overlap
                    :color="list.length ? '#dd2e21' : '#408e27'"
                >
                    <template v-slot:badge>
                        <span v-if="list.length"> {{ list.length }}</span>
                        <v-icon v-else>done</v-icon>
                    </template>
                    <v-icon>{{ icon }}</v-icon>
                </v-badge>
            </v-btn>
        </template> -->
        <v-list  class="container-feedbacks">
            <v-list-item>
                <v-list-item-title>
                    {{ name }}
                </v-list-item-title>
            </v-list-item>
            <v-list-item-content>
                <div v-if="list.length === 0">
                    <v-container class="container-dark">
                        {{$t('partials.feedback_item.no_item', {itemName: name.toLowerCase()})}}
                    </v-container>
                </div>
                <template v-else>
                    <v-container class="container-dark">
                        <template v-for="item in list">
                            <v-alert
                                :key="item.uid"
                                :type="type"
                                :dismissible="name === $t('app.feedback_name.alert')"
                                class="feedback"
                                @input="acquitAlert(item)"
                            >
                                {{ item.message }}
                            </v-alert>
                        </template>
                    </v-container>
                </template>
            </v-list-item-content>
        </v-list>
    </v-menu>
</template>

<script>

export default {

    components: {

    },

    props: {
        name: {
            type: String,
            required: true,
        },
        list: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            default: 'info',
        },
        icon: {
            type: String,
            required: true,
        }
    },

    data (){
        return {
            show: true,
        };
    },

    computed: {
        showBadge (){
            return this.list.length > 0;
        },
    },

    mounted (){

    },

    methods: {
        acquitAlert (item){
            this.$store.dispatch('patchItem', {
                item: {
                    url: item.url,
                    acquited: true,
                },
                model: 'alerts'
            }).then(() => {
                this.$store.dispatch('fetchModelByName', 'alerts');
            });
        }
    },
};
</script>

<style lang="scss">
.feedback-badge .v-badge__badge{
    height: 16px;
    width: 16px;
    span{
        line-height: 12px;
    }
}
.container-feedbacks{
    width: 300px;
    padding-bottom: 0;

    .container-dark{
        background-color: #3a3939;
        width: 300px;
    }

    .feedback{
        margin: 5px 10px;
        width: -webkit-fill-available;
        width: -moz-available;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/feedback-item.vue